import { useNavigate } from "react-router-dom";
import styles from "./Styles.module.scss";
import Button from "../../../components/common/button/Button";
import { useTranslation } from "react-i18next";

const Error = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("translation");

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <h2>{t("error_title")}</h2>
        <p>{t("error_subtitle")}</p>
        <Button onClick={() => navigate("/")}>{t("back_home")}</Button>
      </div>
    </div>
  );
};

export default Error;
